import {
  ActionType,
  IConsultationListResponse,
  ConsultationsPayload,
} from "models/consultations/consultationList";

export const getConsultationListAction = (payload: ConsultationsPayload) => {
  return {
    type: ActionType.GET_CONSULTATION_LIST,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.GET_CONSULTATION_LIST_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IConsultationListResponse) => {
  return {
    type: ActionType.GET_CONSULTATION_LIST_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.GET_CONSULTATION_LIST_RESET,
  };
};
